<template>
  <div class="container">
    <a v-if="model.chat && model.chat_enabled" class="action" href="#" @click.prevent="openChat">
      <div class="description">
        <span>
          {{ $t("webstars.buttons.chat.title") }}
        </span>
      </div>
    </a>
    <ModalChatWithModel :model="model" v-if="showModal" @cancel="showModal = false" />
  </div>
</template>

<script setup lang="ts">
import { Model } from "~/types/Model";

const { model } = defineProps<{
  model: Model;
}>();

const showModal = ref(false);

function openChat() {
  switch (model.chat.case) {
    case "open_chat":
      window.location.href = model.chat.url;
      break;

    case "modal_login":
    case "modal_subscription":
      showModal.value = true;
      break;

    default:
      break;
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";
@import "@/assets/scss/classes";

.container {
  display: flex;
}

.action {
  @extend %fresh-btn;
  border-radius: 0.5rem;
  padding-inline: 0.25em;

  .description {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;

    span {
      font-size: 600;
      font-size: .75em;
      text-wrap: nowrap;
    }
  }
}
.chat-subtitle-username {
  color: var(--pallete_main_color);
}
</style>
